import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PopovercomponentPage} from './popovercomponent';

@NgModule({
  declarations: [
    PopovercomponentPage,
  ],
  imports: [
    IonicPageModule.forChild(PopovercomponentPage),
  ],
})
export class PopovercomponentPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/popovercomponent/popovercomponent.module.ts